<template>
    <div>
        <label>{{ i18n("voucherDesign.backgroundColor") }}:</label>
        <div>
            <EditorColorPicker
                v-if="editor"
                :title="i18n('voucherDesign.backgroundColor')"
                icon="fas fa-fill"
                v-model="modelValue"
                :showColorCode="true"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { i18n } from "@/portal/Trans";
    import type { Editor } from "@tiptap/vue-3";

    import EditorColorPicker from "@/portal/components/vouchers/editor/EditorColorPicker.vue";

    defineProps<{
        editor: Editor;
    }>();

    const modelValue = defineModel<string>("backgroundColor", { required: true });
</script>
